/**
 * Module: `export/markdown-line-breaks.ts` — soft line breaks → hard line breaks.
 *
 * pdfmake renders a raw `\n` inside a paragraph as a line break, Word does not.
 * Marking those breaks as Markdown hard breaks (two trailing spaces) yields a
 * `break` mdast node, which both renderers turn into an actual line break.
 */

const FENCE_LINE_REGEX = /^\s{0,3}(?:`{3,}|~{3,})/;
const HARD_BREAK_SUFFIX = "  ";

export function hardenSoftLineBreaks(markdown: string): string {
  const lines = markdown.split("\n");
  let insideFencedCode = false;

  return lines
    .map((line, index) => {
      if (FENCE_LINE_REGEX.test(line)) {
        insideFencedCode = !insideFencedCode;
        return line;
      }
      if (insideFencedCode) return line;

      const continuesParagraph =
        line.trim().length > 0 && (lines[index + 1]?.trim().length ?? 0) > 0;
      if (!continuesParagraph || line.endsWith(HARD_BREAK_SUFFIX)) return line;

      return `${line}${HARD_BREAK_SUFFIX}`;
    })
    .join("\n");
}
